<div id="stats" class="stats-container p-2">
  <div class="row g-4">
    <div class="col-12 col-lg-6">
      <div class="card booking-card h-100">
        <div class="card-header booking-card__header">
          <div>
            <div class="booking-card__eyebrow">Trends</div>
            <h4 class="sub-title mb-0">Monthly Consultation Summary</h4>
          </div>
        </div>
        <div class="card-body p-3">
          <ag-charts [options]="monthlyBookingsChartOptions"></ag-charts>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6">
      <div class="card booking-card h-100">
        <div class="card-header booking-card__header">
          <div>
            <div class="booking-card__eyebrow">Medical Statistics</div>
            <h4 class="sub-title mb-0">Top Diagnoses Distribution</h4>
          </div>
        </div>
        <div class="card-body p-3">
          <ag-charts [options]="topDiagnosesChartOptions"></ag-charts>
        </div>
      </div>
    </div>
  </div>

  <!-- Top Doctors Table -->
  <div class="card booking-card mt-4">
    <div class="card-header booking-card__header">
      <div>
        <div class="booking-card__eyebrow">Performance Rankings</div>
        <h4 class="sub-title mb-0">Top Doctors by Consultations</h4>
      </div>
      <span
        class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-2"
      >
        This Month
      </span>
    </div>

    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead>
            <tr>
              <th>Doctor Name</th>
              <th>City</th>
              <th class="text-end">Consultations</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doctor of topDoctors">
              <td class="fw-bold text-dark">
                <i class="bi bi-person-circle me-2 text-primary"></i>{{ doctor.name }}
              </td>
              <td>
                <span class="text-muted"><i class="bi bi-geo-alt me-1"></i>{{ doctor.city }}</span>
              </td>
              <td class="text-end">
                <span
                  class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-1 fw-bold"
                >
                  {{ doctor.consultations }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ng-template #Stats>
    <div class="empty-state">
      <i class="bi bi-bar-chart fs-1 d-block mb-2 text-primary"></i>
      <h5>No Previous Bookings</h5>
      <p class="text-muted small">Analytics will appear here as consultations are completed.</p>
    </div>
  </ng-template>
</div>
